export default function changeStatePasswordInput(inputId, handlerId) {
    const showPsw = "show-psw"
    const hidePsw = "hide-psw"
    const input = document.querySelector(inputId)
    const btn = document.querySelector(handlerId)
    btn.addEventListener('click', ()=>{
        if(btn.classList.contains(showPsw)) {
            btn.classList.remove(showPsw)
            btn.classList.add(hidePsw)
            input.type = "password"
        } else {
            btn.classList.remove(hidePsw)
            btn.classList.add(showPsw)
            input.type = "text"
        }
    })
  }